import { Component } from '@angular/core';

@Component({
  selector: 'app-contacto',
  imports: [],
  templateUrl: './contacto.component.html',
  styleUrl: './contacto.component.css'
})
export class ContactoComponent {
  contactInfo = {
    name: "Matías Quiroga",
    email: "tropilleros@gmail.com",
    phone: "+54 9 11-6437-7993",
    whatsappLink: "https://wa.me/5491164377993"
  };
  
  riders = [
    { name: "Rider Acústico", file: "assets/rider-acustico.pdf" },
    { name: "Rider Completo", file: "assets/rider-completo.pdf" }
  ];
  
}
